import NFAnalytics from 'shared/helpers/analytics/NFAnalytics';

import { TRACK_TYPE } from 'shared/helpers/analytics/constants';
import { ERROR_EVENTS } from 'shared/helpers/analytics/constants/errors';
import { TEXT } from './constants';

export const onPageLoad = () => {
  NFAnalytics.track({
    data: {
      errorCode: '500',
      errorMessage: TEXT.INFO,
    },
    type: TRACK_TYPE.PAGELOAD,
    event: ERROR_EVENTS.ERROR_PAGE_LOADS,
  });
};
